import { Route } from '@angular/router';
import {InputCurrentContractComponent} from '../../../../../../pages';
import {
    AircraftDeliveryMethodsResolver, AirportDeliveryMethodsResolver,
    CurrenciesResolver,
    FuelPreferenceResolver,
    PaymentMethodsResolver,
    PaymentTypesResolver, UnitsResolver
} from '../../../../../../../common/routing/resolvers';
import {TenderAnalyticsInputCurrentContractResolver} from '../../../../../resolvers';

export const inputCurrentContractRoute: Route = {
    path: 'input-current-contract',
    component: InputCurrentContractComponent,
    resolve: {
        paymentTypesCollection: PaymentTypesResolver,
        paymentMethodsCollection: PaymentMethodsResolver,
        inputCurrentOffer: TenderAnalyticsInputCurrentContractResolver,

        fuelPreferenceCollection: FuelPreferenceResolver,
        currencyCollection: CurrenciesResolver,
        unitsCollection: UnitsResolver,
        aircraftDeliveryMethodsCollection: AircraftDeliveryMethodsResolver,
        airportDeliveryMethodsCollection: AirportDeliveryMethodsResolver,
    },
};
